import type { SVGProps } from 'react';

const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m19.59 7.56-6-3.75c-.97-.6-2.21-.6-3.18 0l-6 3.75C3.53 8.11 3 9.06 3 10.1v7.89c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V10.1c0-1.04-.53-1.99-1.41-2.54M14 19h-4v-6h4zm5-1c0 .55-.45 1-1 1h-2v-6c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6H6c-.55 0-1-.45-1-1v-7.89c0-.35.18-.66.47-.85l6-3.75c.16-.1.34-.15.53-.15s.37.05.53.15l6 3.75c.29.18.47.5.47.85z"
    />
  </svg>
);
export default SvgHome;
